module.exports = __webpack_public_path__ + "static/media/instagram.87d02d50.svg";